import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';
import { getStatusForAllWords } from './util.get-status-for-words.js';

const makeInput = bindInputMaker();
const textCorrectionInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("text-correction").default("text-correction"),
      text: z.string().default(""),
      validationType: z.enum(["with-start-comma", "without-start-comma"]).default("with-start-comma")
    }),
    getStatusForAllWords: (node, entry) => !node || !entry ? [] : getStatusForAllWords({
      initialInput: node.initialText,
      userInput: entry.text,
      correctAnswer: "expectedText" in node.validation ? node.validation.expectedText : entry.validationType === "with-start-comma" ? node.validation.withStartComma : node.validation.withoutStartComma
    }),
    getStatusForOriginalWords: (node, entry) => {
      if (!node || !entry) {
        return [];
      }
      const validation = getStatusForAllWords({
        initialInput: node.initialText,
        userInput: entry.text,
        correctAnswer: "expectedText" in node.validation ? node.validation.expectedText : entry.validationType === "with-start-comma" ? node.validation.withStartComma : node.validation.withoutStartComma
      });
      return validation.filter(it => it.essential && it.state === "neutral");
    },
    shouldValidate: node => "expectedText" in node.validation && !!node.validation.expectedText || "withStartComma" in node.validation && !!node.validation.withStartComma && !!node.validation.withoutStartComma,
    validate: (node, entry) => {
      const validation = getStatusForAllWords({
        initialInput: node.initialText,
        userInput: entry.text,
        correctAnswer: "expectedText" in node.validation ? node.validation.expectedText : entry.validationType === "with-start-comma" ? node.validation.withStartComma : node.validation.withoutStartComma
      }).filter(it => it.essential);
      return validation.reduce((acc, curr) => ({
        correct: acc.correct + (curr.correct ? 1 : 0),
        wrong: acc.wrong + (curr.correct ? 0 : 1)
      }), {
        correct: 0,
        wrong: 0
      });
    },
    parseLegacyDetailItem: (item, context) => {
      if (["TextCorrection"].includes(context.relatedTask.taskType) && item && typeof item === "object" && "input" in item && typeof item.input === "string" && "selectedAnswer" in item && typeof item.selectedAnswer === "number") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "text-correction",
          text: item.input,
          validationType: item.selectedAnswer === 0 ? "with-start-comma" : "without-start-comma"
        }];
      }
    }
  },
  schema: z.string(),
  postprocessSchemaInput: (initialText, context) => {
    const expectedText = context.correctAnswer.find(it => it.title === "Facit");
    const expectedWithStartComma = context.correctAnswer.find(it => it.title === "Med startkomma");
    const expectedWithoutStartComma = context.correctAnswer.find(it => it.title === "Uden startkomma");
    return {
      id: `${context.taskId}-input`,
      nodeType: "text-correction-input",
      initialText,
      validation: expectedWithStartComma && expectedWithoutStartComma ? {
        withStartComma: expectedWithStartComma.text,
        withoutStartComma: expectedWithoutStartComma.text
      } : {
        expectedText: expectedText?.text ?? expectedWithStartComma?.text ?? expectedWithoutStartComma?.text ?? ""
      }
    };
  }
});

export { textCorrectionInput };
//# sourceMappingURL=input.text-correction.js.map
